import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { TravelAddress, type TravelAddressConstructor } from './TravelAddress'

export const TravelAddressConstructorFactory =
  Factory.Sync.makeFactory<TravelAddressConstructor>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.company.companyName()),
    addressLineOne: Factory.each(() => faker.address.streetAddress()),
    city: Factory.each(() => faker.address.city()),
    stateProvince: Factory.each(() => faker.address.state()),
    country: Factory.each(() => faker.address.country()),
    postalCode: Factory.each(() => faker.address.zipCode()),
  })

export const TravelAddressFactory = EntityFactory(
  TravelAddress,
  TravelAddressConstructorFactory
)
